let host = window.location.host;

const testUrls = ['test2', 'alitest', 'alitest1','assemble', 'pre'];

let collegeUrl = '';

if (testUrls.indexOf(host.substr(0, host.indexOf('.'))) > -1) {
  collegeUrl = 'https://13766-nygpt-sl-ipu.it.test.sankuai.com/app/course/courseCatalog';
} else {
  collegeUrl = 'https://rms-ipu.sankuai.com/app/course/courseCatalog';
}

const menu = [{
  id: '9',
  name: '首页',
  icon: 'icon-shouyehq',
  path: '/'
}, {
  id: '20',
  name: '菜品管理',
  path: 'Menu',
  icon: 'icon-caipinguanli',
  children: [{
    id: '201003',
    name: '菜品库',
    oldPath: '/hq-web/food/stock'
  }, {
    id: '202001',
    name: '总部菜谱',
    path: '/Menu/MenuHqList'
  }, {
    id: '206001',
    name: '菜谱发布管理',
    path: '/Menu/MenuManage'
  }]
}, {
  id: '30',
  path: 'Payment',
  name: '支付优惠',
  icon: 'icon-zhifuyouhui',
  children: [{
    id: '301001',
    name: '付款方式',
    // oldPath: '/hq-web/pay/method'
    path: '/Payment/PayMethod'
  }, {
    id: '302001',
    name: '折扣方案',
    oldPath: '/hq-web/pay/discount'
  }, {
    id: '303001',
    name: '服务费',
    oldPath: '/hq-web/pay/fee'
  }]
}, {
  id: '40',
  name: '辅助信息',
  icon: 'icon-fuzhuxinxi',
  children: [{
    id: '4010',
    name: '辅助信息',
    sign: [401001, 402001, 403001, 404001, 405001, 406001],
    oldPath: 'AUXI'
  }]
}, {
  id: '100',
  name: '扫码点餐',
  icon: 'icon-weicanting',
  children: [{
    id: '10010',
    name: '扫码点餐展示',
    sign: [100100101, 100100201],
    oldPath: 'WCT_SHOW'
  }, {
    id: '1002001',
    name: '公众号授权设置',
    oldPath: '/hq-web/wct/auth'
  }, {
    id: '10030',
    name: '二维码管理',
    sign: [100300101, 100300201],
    oldPath: 'WCT_QR'
  }]
}, {
  id: '2000000050',
  name: '会员管理',
  path: 'Member',
  icon: 'icon-huiyuanguanli',
  hasNewPoint: true,
  children: [{
    id: '_2000000050A001',
    name: '一键迁移',
    path: '/Member/MemberTransfer',
    hasNewPoint: true
  }, {
    id: '2000503001',
    name: '会员信息',
    oldPath: '/hq-web/crm/member'
  }, {
    id: '2000501001',
    name: '会员卡类型',
    oldPath: '/hq-web/crm/cardtype'
  }, {
    id: '2050200101_2050200201',
    name: '批量制会员卡',
    oldPath: 'CRM_CARD'
  }, {
    id: '2000504001',
    name: '积分兑换方案',
    oldPath: '/hq-web/crm/credit'
  }, {
    id: '2000505001',
    name: '微信会员中心',
    oldPath: '/hq-web/weixin/member'
  }]
}, {
  id: '70',
  name: '门店库存管理',
  icon: 'icon-mendiankucunguanli',
  children: [{
    id: '701001',
    name: '门店采购订单',
    oldPath: '/hq-web/sds/hotel/order'
  }, {
    id: '702001',
    name: '门店直配订单',
    oldPath: '/hq-web/sds/hotel/order/distribution'
  }, {
    id: '702101',
    name: '门店调拨管理',
    oldPath: '/hq-web/sds/hotel/transfer'
  }, {
    id: '701701',
    name: '门店采购统计',
    oldPath: 'HOTEL_PURCHASE'
  }, {
    id: '7011',
    name: '门店报表统计',
    sign: [70110101, 70110201, 70110301, 70110401, 70110501, 70110601, 70110701, 70110801],
    oldPath: 'SDS_HOTEL'
  }, {
    id: '701201',
    name: '门店仓库管理',
    oldPath: '/hq-web/sds/warehouse/list/hotel'
  }, {
    id: '7018',
    name: '原材料管理',
    sign: [70180101, 701802, 701803, 701804],
    oldPath: 'SDS_GOODS'
  }, {
    id: '901001',
    name: '门店原材料调价管理',
    oldPath: '/hq-web/sds/group/priceAgreement/done'
  }, {
    id: '701301',
    name: '门店供应商',
    oldPath: '/hq-web/sds/supplier/list/hotel'
  }, {
    id: '701401',
    name: '门店成本卡',
    oldPath: '/hq-web/sds/hotel/foodsbom'
  }, {
    id: '701501',
    name: '库存数据下发',
    oldPath: '/hq-web/data/issue'
  }]
}, {
  id: '80',
  name: '总部库存管理',
  icon: 'icon-zongdiankucunguanli',
  children: [{
    id: '801001',
    name: '总部订单管理',
    oldPath: '/hq-web/sds/group/order'
  }, {
    id: '801101',
    name: '总部入库管理',
    oldPath: '/hq-web/sds/group/in'
  }, {
    id: '801201',
    name: '总部出库管理',
    oldPath: '/hq-web/sds/group/out'
  }, {
    id: '801301',
    name: '总部调拨管理',
    oldPath: '/hq-web/sds/group/transfer'
  }, {
    id: '801401',
    name: '总部盘点管理',
    oldPath: '/hq-web/sds/group/taking'
  }, {
    id: '8016',
    name: '总部报表统计',
    sign: [80160101, 80160201, 80160301, 80160401, 80160501, 80160601],
    oldPath: 'SDS_GROUP'
  }, {
    id: '801701',
    name: '总部仓库管理',
    oldPath: '/hq-web/sds/warehouse/list/group'
  }, {
    id: '801801',
    name: '总部供应商',
    oldPath: '/hq-web/sds/supplier/list/group'
  }, {
    id: '801901',
    name: '工作流配置',
    oldPath: '/hq-web/sds/group/workflow'
  }]
}, {
  id: '60',
  name: '营业收入报表',
  path: 'BusinessReport',
  icon: 'icon-yingyeshourubaobiao',
  children: [{
    id: '601001',
    name: '营业汇总表',
    path: '/BusinessReport/BusiStatistics'
  }, {
    id: '601101',
    name: '交班信息表',
    path: '/BusinessReport/GetoDuty'
  }, {
    id: '601201',
    name: '付款类型汇总表',
    path: '/BusinessReport/PayType'
  }, {
    id: '601401',
    name: '堂食时段账单统计表',
    path: '/BusinessReport/BillDetail'
  }, {
    id: '601501',
    name: '开票统计表',
    path: '/BusinessReport/InvoiceReport'
  }, {
    id: '601601',
    name: '结算信息统计表',
    path: '/BusinessReport/SettlementStatistics'
  }]
}, {
  id: '110',
  name: '菜品销售报表',
  path: 'FoodReport',
  icon: 'icon-caipinxiaoshoubaobiao',
  children: [{
    id: '1101001',
    name: '菜品销售汇总表',
    path: '/FoodReport/Gather'
  }, {
    id: '1101101',
    name: '菜品销售排行',
    path: '/FoodReport/Rank'
  }, {
    id: '1101201',
    name: '菜品分类占比',
    path: '/FoodReport/FoodType'
  }, {
    id: '1101501',
    name: '加料销售报表',
    path: '/FoodReport/AdditionSaleReport'
  }, {
    id: '1101301',
    name: '菜品时段销售表',
    path: '/FoodReport/Period'
  }, {
    id: '1101401',
    name: '菜品销售提成表',
    path: '/FoodReport/Commission'
  }]
}, {
  id: '2000000120',
  name: '会员相关报表',
  icon: 'icon-huiyuanxiangguanbaobiao',
  children: [{
    id: '2001201001',
    name: '会员统计表',
    oldPath: '/hq-web/report/crm/member/stat'
  }, {
    id: '2001201101',
    name: '会员充值明细表',
    oldPath: '/hq-web/report/crm/card/recharge'
  }, {
    id: '2001201201',
    name: '会员储值结算报表',
    oldPath: '/hq-web/report/crm/card/balance'
  }, {
    id: '2001201301',
    name: '门店结算报表',
    oldPath: '/hq-web/report/crm/hotelMemberBalance'
  }]
}, {
  id: '130',
  name: '收银异常操作',
  path: 'CashierException',
  icon: 'icon-shouyinyichangbaobiao',
  children: [{
    id: '1301001',
    name: '赠送明细表',
    path: '/CashierException/FoodGift'
  }, {
    id: '1301101',
    name: '退菜明细表',
    path: '/CashierException/FoodBack'
  }, {
    id: '1301201',
    name: '免单明细表',
    path: '/CashierException/FreeOfChargeDetail'
  }, {
    id: '1301301',
    name: '折扣明细表',
    path: '/CashierException/DiscountDetail'
  }, {
    id: '1301401',
    name: '反结明细表',
    path: '/CashierException/AntiSettlement'
  }]
}, {
  id: '190',
  name: '历史数据查询',
  icon: 'icon-huiyuanxiangguanbaobiao',
  children: [{
    id: '1901001',
    name: '会员统计表',
    oldPath: '/hq-web/report/crm/member/stat'
  }, {
    id: '1902001',
    name: '会员充值明细表',
    oldPath: '/hq-web/report/crm/card/recharge'
  }, {
    id: '1903001',
    name: '会员储值结算报表',
    oldPath: '/hq-web/report/crm/card/balance'
  }, {
    id: '1904001',
    name: '门店结算报表',
    oldPath: '/hq-web/report/crm/hotelMemberBalance'
  }]
}, {
  id: '140',
  name: '系统设置',
  path: 'System',
  icon: 'icon-xitongshezhi',
  children: [{
    id: '14010',
    name: '预约下载中心',
    path: '/System/Download',
    className: 'appoint-download',
  }]
}, {
  id: '9600',
  name: '服务中心',
  path: 'Service',
  icon: 'icon-fuwuzhongxin',
  children: [{
    id: "9601",
    name: "帮助中心",
    path: "https://rms-help.meituan.com/web/fe.rms-help-pro/index.html?appCode=100&module=1001",
  },
  {
    id: "9602",
    name: "收银讲堂",
    path: collegeUrl,
  },
  {
    id: "9603",
    name: "软件下载",
    path: "/Service/DownloadCenter",
  }]
}];


export default menu;



// WEBPACK FOOTER //
// ./src/constants/menu-crm.js